<template>
  <div>
    <BaseDialog
      v-model="showDialog"
      title="Prosjekt info"
      dialogIcon="mdi-information-variant"
      scrollable
      @close="$emit('close')"
    >
      <template v-slot>
        <CardContent v-model="info" />
      </template>
    </BaseDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";

import { projectObject } from "@/types/projectInterface";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import CardContent from "@/components/shared/cards/children/CardContent.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    project: {
      type: Object as () => projectObject,
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
    }),
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    info(): Array<any> {
      var items = [
        {
          icon: "mdi-home-city-outline",
          title: "Prosjekt",
          content: this.project?.name,
        },
        {
          icon: "mdi-home-outline",
          title: "Type",
          content: this.project?.projTypeName,
        },
        {
          icon: "mdi-map-marker-outline",
          title: "Adresse",
          content: this.project?.address,
          href: this.project?.address
            ? `http://maps.google.com/maps?q=${this.project?.address} ${
                this.project?.postCode
                  ? `, ${this.project?.postCode?.postCodeText}`
                  : ""
              }`
            : "",
          target: "_blank",
        },
        {
          icon: "mdi-map-marker-outline",
          title: "Poststed",
          content: this.project?.postCode?.display,
        },
        // {
        //   icon: "mdi-office-building-outline",
        //   title: "Antall seksjoner",
        //   content: this.project?.totSections,
        // },
      ];

      return items;
    },
  },
  components: {
    BaseDialog,
    CardContent,
  },
});
</script>
